import { render } from "./BlankView.vue?vue&type=template&id=35cb2230"
import script from "./BlankView.vue?vue&type=script&lang=js"
export * from "./BlankView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "35cb2230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35cb2230', script)) {
    api.reload('35cb2230', script)
  }
  
  module.hot.accept("./BlankView.vue?vue&type=template&id=35cb2230", () => {
    api.rerender('35cb2230', render)
  })

}

script.__file = "src/views/misc/BlankView.vue"

export default script